import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import backgroundImage from "./gallery/promo_03.jpg";
import { routes } from "config";
import talesOfBeedleTheBard from "assets/replicas/harry-potter/hp-tales-of-beedle-the-bard";
import talesOfBeedleTheBardV1 from "assets/replicas/harry-potter/hp-tales-of-beedle-the-bard/v1";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.05,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        While creating the full{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", talesOfBeedleTheBard.id).replace(":version", `v${talesOfBeedleTheBardV1.version}`)}`}
          target="_blank"
        >
          The Tales of Beedle the Bard v1
        </Link>
        , I ended up with a spare cover, as I had originally planned to create
        more full prop replicas. Rather than let it go to waste, I decided to
        turn it into a DIY version paired with a 3D-printed book block that
        simulates layered sheets of paper. This allows the DIY cover to serve
        two purposes. First, it functions as a lightweight alternative to the
        full prop. From the outside, the cover looks identical to the complete
        version, offering the same visual appeal if all you want is a decorative
        piece for your shelf. You can even use it as a box to hide things
        inside. Second, and perhaps more importantly, the cover can be easily
        separated from the 3D-printed block, allowing you to mount it onto your
        own book block, whether from a pre-existing book or a custom-made one.
        This makes it a sort of DIY kit for creating your own full prop replica.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="300px"
        imageOptions={[{ index: 5, aspectRatio: 1.7 }]}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        The design of the cover maintains all the visual fidelity of the
        original prop, with the 3D-printed block serving as a placeholder for
        the actual book block. As mentioned above, the cover can be easily
        removed from the block - since I made this to be taken apart, the cover
        is attached to the 3D printed block with just four small pieces of
        double-sided tape in each corner, so, with enough care, you can easily
        peel it off without damaging the canvas of the cover. Once the cover is
        removed, you can then stick it onto your own book block and voilà -
        you've got yourself a full prop of the Tales of Beedle the Bard!
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={1}
        aspectRatio={1}
        imageMaxHeight="400px"
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        Please note that this is not a final 'product' - while it can be used as
        a standalone decoration, it is primarily intended as a DIY kit for
        people to create their own full prop replicas without the means of
        creating the intricate cover.
      </ReplicaParagraph>
    </ReplicaContent>
  );
};

export default Page;
export { background };
